export default __webpack_public_path__ + "static/media/EcomGateway-Direct.209820c3.yaml";